<div class="breadcrumbs">
    <p-menubar [model]="items"></p-menubar>
</div>